export default {"src":"/_next/static/media/telegram.b8ecca78.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};